var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineTool(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2751_121560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.833496 16.6666H19.1668V9.99998H0.833496V16.6666ZM1.66683 10.8333H18.3335V15.8333H17.5002V13.3333H16.6668V15.8333H15.8335V14.1666H15.0002V15.8333H14.1668V11.6666H13.3335V15.8333H12.5002V14.1666H11.6668V15.8333H10.8335V13.3333H10.0002V15.8333H9.16683V14.1666H8.3335V15.8333H7.50016V11.6666H6.66683V15.8333H5.8335V14.1666H5.00016V15.8333H4.16683V13.3333H3.3335V15.8333H1.66683V10.8333ZM16.6668 3.33331V4.16665H3.3335V3.33331H0.833496V5.83331H3.3335V4.99998H16.6668V5.83331H19.1668V3.33331H16.6668ZM2.50016 4.99998H1.66683V4.16665H2.50016V4.99998ZM18.3335 4.99998H17.5002V4.16665H18.3335V4.99998Z",
    fill: "#444444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2751_121560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineTool);
export default __webpack_public_path__ + "static/media/lineTool.8ce724fe412920a4d105909a9f934c29.svg";
export { ForwardRef as ReactComponent };